'use client';

import React from 'react';

import { Box, BoxProps } from '../box';

export interface DividerProps extends BoxProps {
  /** Orientation of the divider */
  orientation?: 'horizontal' | 'vertical';
  /** Thickness of the divider */
  thickness?: string | number;
  /** Color of the divider */
  color?: string;
}

/**
 * Divider component for visual separation
 */
export const Divider: React.FC<DividerProps> = ({
  orientation = 'horizontal',
  thickness = '1px',
  color = 'border.muted',
  ...boxProps
}) => {
  const isVertical = orientation === 'vertical';

  return (
    <Box
      width={isVertical ? thickness : 'full'}
      height={isVertical ? 'full' : thickness}
      backgroundColor={color}
      flexShrink={0}
      {...boxProps}
    />
  );
};

export default Divider;
